/* Keel product section: option picker, live delivery window, launch countdown, gallery, sticky add-to-cart. */
(function () {
  if (window.__keelLoaded) return;
  window.__keelLoaded = true;

  function addWorkdays(date, n) {
    var d = new Date(date);
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) n--;
    }
    return d;
  }

  function initEta(root) {
    root.querySelectorAll('[data-keel-eta]').forEach(function (el) {
      var min = parseInt(el.dataset.min, 10) || 6;
      var max = parseInt(el.dataset.max, 10) || 8;
      var locale = el.dataset.locale || 'en-GB';
      var fmt = function (d) {
        try { return d.toLocaleDateString(locale, { weekday: 'short', day: 'numeric', month: 'short' }); }
        catch (e) { return d.toDateString(); }
      };
      var now = new Date();
      el.textContent = fmt(addWorkdays(now, min)) + ' – ' + fmt(addWorkdays(now, max));
    });
  }

  function initLaunch(root) {
    root.querySelectorAll('[data-keel-launch]').forEach(function (el) {
      var end = new Date(el.dataset.end + 'T23:59:59');
      if (isNaN(end)) return;
      var days = Math.ceil((end - new Date()) / 864e5);
      if (days < 1) { el.hidden = true; return; }
      var out = el.querySelector('[data-keel-days]');
      if (out) out.textContent = days === 1 ? el.dataset.lastDay : el.dataset.daysLeft.replace('{days}', days);
    });
  }

  function initProduct(root) {
    root.querySelectorAll('[data-keel-product]').forEach(function (section) {
      var radios = section.querySelectorAll('input[name="id"][type="radio"]');
      var priceOut = section.querySelectorAll('[data-keel-price]');
      var payOut = section.querySelector('[data-keel-paylater]');
      var stock = section.querySelector('[data-keel-stock]');
      var stickyTier = section.querySelector('[data-keel-sticky-tier]');
      var buttons = section.querySelectorAll('[data-keel-atc]');

      function update() {
        var r = section.querySelector('input[name="id"][type="radio"]:checked');
        if (!r) return;
        var d = r.dataset;
        priceOut.forEach(function (el) { el.textContent = d.price; });
        if (payOut && payOut.dataset.template) {
          payOut.textContent = payOut.dataset.template.replace('{amount_3}', d.amount3).replace('{amount_4}', d.amount4);
        }
        if (stickyTier) stickyTier.textContent = d.title + ' · ' + d.price;
        if (stock) {
          var n = parseInt(d.stock, 10);
          var threshold = parseInt(stock.dataset.threshold, 10) || 50;
          var show = n > 0 && n < threshold;
          stock.hidden = !show;
          if (show) {
            stock.querySelector('[data-keel-stock-text]').textContent = stock.dataset.template.replace('{count}', n);
            stock.querySelector('i').style.width = Math.max(6, Math.round((n / threshold) * 100)) + '%';
          }
        }
        var bonus = section.querySelector('[data-keel-bonus]');
        if (bonus) bonus.hidden = d.bonus !== 'true';
        var available = d.available === 'true';
        buttons.forEach(function (b) {
          b.disabled = !available;
          var label = b.querySelector('[data-keel-atc-label]');
          if (label) label.textContent = available ? b.dataset.labelAdd : b.dataset.labelSoldout;
        });
      }
      radios.forEach(function (r) { r.addEventListener('change', update); });
      update();

      // Gallery
      var slides = section.querySelectorAll('.keel-gallery__slide');
      section.querySelectorAll('.keel-gallery__thumb').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var i = thumb.dataset.index;
          slides.forEach(function (s) {
            var on = s.dataset.index === i;
            s.hidden = !on;
            if (!on) s.querySelectorAll('video').forEach(function (v) { v.pause(); });
          });
          section.querySelectorAll('.keel-gallery__thumb').forEach(function (t) {
            t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
          });
          var strip = thumb.parentElement;
          if (strip && strip.scrollWidth > strip.clientWidth) {
            strip.scrollTo({ left: thumb.offsetLeft - (strip.clientWidth - thumb.offsetWidth) / 2, behavior: 'smooth' });
          }
          var shown = section.querySelector('.keel-gallery__slide[data-index="' + i + '"] video');
          if (shown && !reducedMotion()) shown.play().catch(function () {});
        });
      });

      // Swipe the main gallery on touch screens
      var main = section.querySelector('.keel-gallery__main');
      var thumbs = section.querySelectorAll('.keel-gallery__thumb');
      if (main && thumbs.length > 1 && !main.dataset.keelSwipe) {
        main.dataset.keelSwipe = '1';
        var x0 = null, y0 = null;
        main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
        main.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
          x0 = null;
          if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
          var cur = Array.prototype.findIndex.call(thumbs, function (t) { return t.getAttribute('aria-current') === 'true'; });
          var next = (cur + (dx < 0 ? 1 : -1) + thumbs.length) % thumbs.length;
          thumbs[next].click();
        }, { passive: true });
      }

      // Sticky bar appears once the main add-to-cart button has scrolled above the viewport
      var sticky = section.querySelector('[data-keel-sticky]');
      var mainBtn = section.querySelector('[data-keel-atc-main]');
      if (sticky && mainBtn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var e = entries[0];
          sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
        }).observe(mainBtn);
      }
    });
  }


  /**
   * Adds items via Horizon's own cart events, so the cart drawer re-renders and opens.
   * Returns false when the drawer isn't available, so the caller can fall back to a normal form post.
   */
  async function addToCart(items, sourceEl) {
    var sectionIds = Array.prototype.map.call(document.querySelectorAll('cart-items-component'), function (el) {
      return el.dataset.sectionId;
    }).filter(Boolean);
    if (!sectionIds.length) return false;

    var Ev;
    try { Ev = (await import('@shopify/events')).CartLinesUpdateEvent; } catch (e) { return false; }
    if (!Ev) return false;

    var deferred = Ev.createPromise();
    sourceEl.dispatchEvent(new Ev({
      action: 'add',
      context: 'product',
      lines: items.map(function (i) { return { merchandiseId: String(i.id), quantity: i.quantity || 1 }; }),
      promise: deferred.promise
    }));

    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    try {
      var res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items, sections: sectionIds.join(',') })
      });
      var data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Add to cart failed');
      var cart = await (await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json();
      deferred.resolve({
        cart: Ev.createCartFromAjaxResponse(cart),
        detail: { items: cart.items, source: 'keel', sections: data.sections, didError: false }
      });
      return true;
    } catch (err) {
      deferred.resolve({ detail: { didError: true } });
      alert(err.message);
      return true;
    }
  }

  function initAjaxForm(root) {
    root.querySelectorAll('[data-keel-product] form[id^="keel-form-"]').forEach(function (form) {
      if (form.dataset.keelAjax) return;
      form.dataset.keelAjax = '1';
      form.addEventListener('submit', function (e) {
        if (form.querySelector('input[name="return_to"]')) return; // "skip basket" mode: normal post to checkout
        e.preventDefault();
        var id = (form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"]') ||
                  document.querySelector('input[name="id"][form="' + form.id + '"]:checked'));
        if (!id) { form.submit(); return; }
        var buttons = document.querySelectorAll('[data-keel-atc]');
        buttons.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
        addToCart([{ id: Number(id.value), quantity: 1 }], form).then(function (handled) {
          buttons.forEach(function (b) { b.removeAttribute('aria-busy'); });
          if (!handled) form.submit();
        });
      });
    });
  }

  // Refill add-on in the cart drawer / cart page (content is re-rendered, so delegate)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-keel-add]');
    if (!btn) return;
    e.preventDefault();
    btn.setAttribute('aria-busy', 'true');
    addToCart([{ id: Number(btn.dataset.keelAdd), quantity: 1 }], btn).then(function (handled) {
      btn.removeAttribute('aria-busy');
      if (!handled) window.location.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/add?id=' + btn.dataset.keelAdd + '&quantity=1';
    });
  });

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  // Videos act as moving photos; with reduced motion they show only their poster frame
  function initVideos(root) {
    root.querySelectorAll('.keel video').forEach(function (v) {
      v.muted = true;
      if (reducedMotion()) {
        v.removeAttribute('autoplay');
        v.pause();
        if (v.dataset.keelPoster !== '1') { v.dataset.keelPoster = '1'; v.load(); }
      } else if (v.closest('.keel-gallery__slide[hidden]')) {
        v.pause();
      }
    });
  }

  // "Tick the ones that sound like you": each row toggles, a live line counts the ticks
  function initTicklists(root) {
    root.querySelectorAll('[data-keel-ticklist]').forEach(function (list) {
      if (list.dataset.keelReady) return;
      list.dataset.keelReady = '1';
      var rows = list.querySelectorAll('li[role="checkbox"]');
      var out = list.querySelector('.keel-article__list-count');
      function update() {
        var n = list.querySelectorAll('li[aria-checked="true"]').length;
        if (!out) return;
        out.textContent = n === 0 ? list.dataset.zeroText
          : list.dataset.countText.replace('{n}', n).replace('{total}', rows.length);
      }
      rows.forEach(function (row) {
        function toggle() { row.setAttribute('aria-checked', row.getAttribute('aria-checked') === 'true' ? 'false' : 'true'); update(); }
        row.addEventListener('click', toggle);
        row.addEventListener('keydown', function (e) { if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); toggle(); } });
      });
    });
  }

  // Advertorial bottom bar slides away while one of the article's own buttons is on screen, so it never covers a CTA
  function initJournalBar(root) {
    root.querySelectorAll('.keel-journal__bar').forEach(function (bar) {
      if (bar.dataset.keelBar || !('IntersectionObserver' in window)) return;
      bar.dataset.keelBar = '1';
      var scope = bar.closest('.keel') || document;
      var inView = new Set();
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) inView.add(e.target); else inView.delete(e.target); });
        bar.classList.toggle('is-hidden', inView.size > 0);
      });
      // The sticky sidebar card is always on screen on desktop, so it doesn't count
      scope.querySelectorAll('.keel-btn').forEach(function (b) { if (!bar.contains(b) && !b.closest('.keel-journal__side')) io.observe(b); });
    });
  }

  // Advertorial comments: relative dates, and posting without leaving the page (falls back to a normal post)
  function initComments(root) {
    root.querySelectorAll('[data-keel-ago]').forEach(function (t) {
      var d = new Date(t.getAttribute('datetime')); if (isNaN(d)) return;
      var mins = Math.round((Date.now() - d) / 60000), out;
      if (mins < 60) out = Math.max(1, mins) + (mins === 1 ? ' minute ago' : ' minutes ago');
      else if (mins < 1440) { var h = Math.round(mins / 60); out = h + (h === 1 ? ' hour ago' : ' hours ago'); }
      else if (mins < 43200) { var dd = Math.round(mins / 1440); out = dd + (dd === 1 ? ' day ago' : ' days ago'); }
      if (out) t.textContent = out;
    });
    root.querySelectorAll('form[data-keel-comment-form]').forEach(function (form) {
      if (form.dataset.keelBound) return;
      form.dataset.keelBound = '1';
      form.addEventListener('submit', function (e) {
        if (!window.fetch || !window.FormData) return;
        e.preventDefault();
        var btn = form.querySelector('[type=submit]');
        if (btn) btn.setAttribute('aria-busy', 'true');
        fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' }).then(function (res) {
          if (!res.ok || /challenge/.test(res.url)) throw new Error('fallback');
          form.querySelectorAll('input, textarea, button, label, .keel-comments__row').forEach(function (el) { el.hidden = true; });
          var ok = form.querySelector('[data-keel-comment-thanks]'); if (ok) ok.hidden = false;
        }).catch(function () { form.submit(); });
      });
    });
  }

  // Announcement bar: one message at a time on phones, with arrows and a slow auto-advance
  function initAnnouncements(root) {
    root.querySelectorAll('[data-keel-ann]').forEach(function (bar) {
      if (bar.dataset.keelBound) return;
      bar.dataset.keelBound = '1';
      var msgs = bar.querySelectorAll('.keel-ann__msg');
      if (msgs.length < 2) return;
      var i = 0;
      function show(n) { msgs[i].classList.remove('is-active'); i = (n + msgs.length) % msgs.length; msgs[i].classList.add('is-active'); }
      var prev = bar.querySelector('[data-keel-ann-prev]'), next = bar.querySelector('[data-keel-ann-next]');
      if (prev) prev.addEventListener('click', function () { show(i - 1); });
      if (next) next.addEventListener('click', function () { show(i + 1); });
      if (!reducedMotion()) setInterval(function () { if (window.innerWidth < 750) show(i + 1); }, 4500);
    });
  }

  // Review cards under the buy box: one at a time, with arrows
  function initReviewCards(root) {
    root.querySelectorAll('[data-keel-rcards]').forEach(function (box) {
      if (box.dataset.keelBound) return;
      box.dataset.keelBound = '1';
      var cards = box.querySelectorAll('.keel-rcard'), i = 0;
      function show(n) { cards[i].classList.remove('is-active'); i = (n + cards.length) % cards.length; cards[i].classList.add('is-active'); }
      var p = box.querySelector('[data-keel-rcards-prev]'), n = box.querySelector('[data-keel-rcards-next]');
      if (p) p.addEventListener('click', function () { show(i - 1); });
      if (n) n.addEventListener('click', function () { show(i + 1); });
    });
  }

  function init(root) {
    initVideos(root);
    initTicklists(root);
    initEta(root);
    initLaunch(root);
    initProduct(root);
    initAjaxForm(root);
    initJournalBar(root);
    initComments(root);
    initAnnouncements(root);
    initReviewCards(root);
  }

  // Review line above the PDP title: jump to the full Judge.me review widget at the bottom
  // (its block id is generated by Shopify), falling back to the carousel section.
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('.keel-rating');
    if (!link) return;
    var target = document.querySelector('[id^="shopify-block-"][id*="review_widget"]') ||
      document.querySelector('.jdgm-review-widget, .jdgm-widget.jdgm-review-widget') ||
      document.getElementById('keel-reviews');
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
